'use client'

import { memo } from 'react'

import { ErrorServiceUnavailable } from '@/components/common/Error'

const MarketSimpleActionPanelError = () => {
  return (
    <div>
      <ErrorServiceUnavailable minHeight="600px" />
    </div>
  )
}

export default memo(MarketSimpleActionPanelError)
